<!-- components/timezone-options.vue -->
<template>
  <selectDropDown
    :options="timeZoneOptionsList"
    :isDisabled="isViewMode"
    placeholder="Search timezones"
    :clientSideSearch="true"
    :selectedValueProp="modelValue"
    @onSelectOption="onChangeTimezoneHandler"
  />
</template>

<script setup>
import { computed } from 'vue';
import selectDropDown from '/src/components/selectDropDown.vue';

const timeZoneList = [
  {
    "name": "Africa/Abidjan",
    "utc": "Africa - Abidjan (UTC +00:00)"
  },
  {
    "name": "Africa/Accra",
    "utc": "Africa - Accra (UTC +00:00)"
  },
  {
    "name": "Africa/Addis_Ababa",
    "utc": "Africa - Addis Ababa (UTC +03:00)"
  },
  {
    "name": "Africa/Algiers",
    "utc": "Africa - Algiers (UTC +01:00)"
  },
  {
    "name": "Africa/Asmara",
    "utc": "Africa - Asmara (UTC +03:00)"
  },
  {
    "name": "Africa/Asmera",
    "utc": "Africa - Asmera (UTC +03:00)"
  },
  {
    "name": "Africa/Bamako",
    "utc": "Africa - Bamako (UTC +00:00)"
  },
  {
    "name": "Africa/Bangui",
    "utc": "Africa - Bangui (UTC +01:00)"
  },
  {
    "name": "Africa/Banjul",
    "utc": "Africa - Banjul (UTC +00:00)"
  },
  {
    "name": "Africa/Bissau",
    "utc": "Africa - Bissau (UTC +00:00)"
  },
  {
    "name": "Africa/Blantyre",
    "utc": "Africa - Blantyre (UTC +02:00)"
  },
  {
    "name": "Africa/Brazzaville",
    "utc": "Africa - Brazzaville (UTC +01:00)"
  },
  {
    "name": "Africa/Bujumbura",
    "utc": "Africa - Bujumbura (UTC +02:00)"
  },
  {
    "name": "Africa/Cairo",
    "utc": "Africa - Cairo (UTC +03:00)"
  },
  {
    "name": "Africa/Casablanca",
    "utc": "Africa - Casablanca (UTC +01:00)"
  },
  {
    "name": "Africa/Ceuta",
    "utc": "Africa - Ceuta (UTC +02:00)"
  },
  {
    "name": "Africa/Conakry",
    "utc": "Africa - Conakry (UTC +00:00)"
  },
  {
    "name": "Africa/Dakar",
    "utc": "Africa - Dakar (UTC +00:00)"
  },
  {
    "name": "Africa/Dar_es_Salaam",
    "utc": "Africa - Dar es Salaam (UTC +03:00)"
  },
  {
    "name": "Africa/Djibouti",
    "utc": "Africa - Djibouti (UTC +03:00)"
  },
  {
    "name": "Africa/Douala",
    "utc": "Africa - Douala (UTC +01:00)"
  },
  {
    "name": "Africa/El_Aaiun",
    "utc": "Africa - El Aaiun (UTC +01:00)"
  },
  {
    "name": "Africa/Freetown",
    "utc": "Africa - Freetown (UTC +00:00)"
  },
  {
    "name": "Africa/Gaborone",
    "utc": "Africa - Gaborone (UTC +02:00)"
  },
  {
    "name": "Africa/Harare",
    "utc": "Africa - Harare (UTC +02:00)"
  },
  {
    "name": "Africa/Johannesburg",
    "utc": "Africa - Johannesburg (UTC +02:00)"
  },
  {
    "name": "Africa/Juba",
    "utc": "Africa - Juba (UTC +02:00)"
  },
  {
    "name": "Africa/Kampala",
    "utc": "Africa - Kampala (UTC +03:00)"
  },
  {
    "name": "Africa/Khartoum",
    "utc": "Africa - Khartoum (UTC +02:00)"
  },
  {
    "name": "Africa/Kigali",
    "utc": "Africa - Kigali (UTC +02:00)"
  },
  {
    "name": "Africa/Kinshasa",
    "utc": "Africa - Kinshasa (UTC +01:00)"
  },
  {
    "name": "Africa/Lagos",
    "utc": "Africa - Lagos (UTC +01:00)"
  },
  {
    "name": "Africa/Libreville",
    "utc": "Africa - Libreville (UTC +01:00)"
  },
  {
    "name": "Africa/Lome",
    "utc": "Africa - Lome (UTC +00:00)"
  },
  {
    "name": "Africa/Luanda",
    "utc": "Africa - Luanda (UTC +01:00)"
  },
  {
    "name": "Africa/Lubumbashi",
    "utc": "Africa - Lubumbashi (UTC +02:00)"
  },
  {
    "name": "Africa/Lusaka",
    "utc": "Africa - Lusaka (UTC +02:00)"
  },
  {
    "name": "Africa/Malabo",
    "utc": "Africa - Malabo (UTC +01:00)"
  },
  {
    "name": "Africa/Maputo",
    "utc": "Africa - Maputo (UTC +02:00)"
  },
  {
    "name": "Africa/Maseru",
    "utc": "Africa - Maseru (UTC +02:00)"
  },
  {
    "name": "Africa/Mbabane",
    "utc": "Africa - Mbabane (UTC +02:00)"
  },
  {
    "name": "Africa/Mogadishu",
    "utc": "Africa - Mogadishu (UTC +03:00)"
  },
  {
    "name": "Africa/Monrovia",
    "utc": "Africa - Monrovia (UTC +00:00)"
  },
  {
    "name": "Africa/Nairobi",
    "utc": "Africa - Nairobi (UTC +03:00)"
  },
  {
    "name": "Africa/Ndjamena",
    "utc": "Africa - Ndjamena (UTC +01:00)"
  },
  {
    "name": "Africa/Niamey",
    "utc": "Africa - Niamey (UTC +01:00)"
  },
  {
    "name": "Africa/Nouakchott",
    "utc": "Africa - Nouakchott (UTC +00:00)"
  },
  {
    "name": "Africa/Ouagadougou",
    "utc": "Africa - Ouagadougou (UTC +00:00)"
  },
  {
    "name": "Africa/Porto-Novo",
    "utc": "Africa - Porto-Novo (UTC +01:00)"
  },
  {
    "name": "Africa/Sao_Tome",
    "utc": "Africa - Sao Tome (UTC +00:00)"
  },
  {
    "name": "Africa/Timbuktu",
    "utc": "Africa - Timbuktu (UTC +00:00)"
  },
  {
    "name": "Africa/Tripoli",
    "utc": "Africa - Tripoli (UTC +02:00)"
  },
  {
    "name": "Africa/Tunis",
    "utc": "Africa - Tunis (UTC +01:00)"
  },
  {
    "name": "Africa/Windhoek",
    "utc": "Africa - Windhoek (UTC +02:00)"
  },
  {
    "name": "America/Adak",
    "utc": "America - Adak (UTC -09:00)"
  },
  {
    "name": "America/Anchorage",
    "utc": "America - Anchorage (UTC -08:00)"
  },
  {
    "name": "America/Anguilla",
    "utc": "America - Anguilla (UTC -04:00)"
  },
  {
    "name": "America/Antigua",
    "utc": "America - Antigua (UTC -04:00)"
  },
  {
    "name": "America/Araguaina",
    "utc": "America - Araguaina (UTC -03:00)"
  },
  {
    "name": "America/Argentina/Buenos_Aires",
    "utc": "Argentina - Buenos Aires (UTC -03:00)"
  },
  {
    "name": "America/Argentina/Catamarca",
    "utc": "Argentina - Catamarca (UTC -03:00)"
  },
  {
    "name": "America/Argentina/ComodRivadavia",
    "utc": "Argentina - ComodRivadavia (UTC -03:00)"
  },
  {
    "name": "America/Argentina/Cordoba",
    "utc": "Argentina - Cordoba (UTC -03:00)"
  },
  {
    "name": "America/Argentina/Jujuy",
    "utc": "Argentina - Jujuy (UTC -03:00)"
  },
  {
    "name": "America/Argentina/La_Rioja",
    "utc": "Argentina - La Rioja (UTC -03:00)"
  },
  {
    "name": "America/Argentina/Mendoza",
    "utc": "Argentina - Mendoza (UTC -03:00)"
  },
  {
    "name": "America/Argentina/Rio_Gallegos",
    "utc": "Argentina - Rio Gallegos (UTC -03:00)"
  },
  {
    "name": "America/Argentina/Salta",
    "utc": "Argentina - Salta (UTC -03:00)"
  },
  {
    "name": "America/Argentina/San_Juan",
    "utc": "Argentina - San Juan (UTC -03:00)"
  },
  {
    "name": "America/Argentina/San_Luis",
    "utc": "Argentina - San Luis (UTC -03:00)"
  },
  {
    "name": "America/Argentina/Tucuman",
    "utc": "Argentina - Tucuman (UTC -03:00)"
  },
  {
    "name": "America/Argentina/Ushuaia",
    "utc": "Argentina - Ushuaia (UTC -03:00)"
  },
  {
    "name": "America/Aruba",
    "utc": "America - Aruba (UTC -04:00)"
  },
  {
    "name": "America/Asuncion",
    "utc": "America - Asuncion (UTC -03:00)"
  },
  {
    "name": "America/Atikokan",
    "utc": "America - Atikokan (UTC -05:00)"
  },
  {
    "name": "America/Atka",
    "utc": "America - Atka (UTC -09:00)"
  },
  {
    "name": "America/Bahia",
    "utc": "America - Bahia (UTC -03:00)"
  },
  {
    "name": "America/Bahia_Banderas",
    "utc": "America - Bahia Banderas (UTC -06:00)"
  },
  {
    "name": "America/Barbados",
    "utc": "America - Barbados (UTC -04:00)"
  },
  {
    "name": "America/Belem",
    "utc": "America - Belem (UTC -03:00)"
  },
  {
    "name": "America/Belize",
    "utc": "America - Belize (UTC -06:00)"
  },
  {
    "name": "America/Blanc-Sablon",
    "utc": "America - Blanc-Sablon (UTC -04:00)"
  },
  {
    "name": "America/Boa_Vista",
    "utc": "America - Boa Vista (UTC -04:00)"
  },
  {
    "name": "America/Bogota",
    "utc": "America - Bogota (UTC -05:00)"
  },
  {
    "name": "America/Boise",
    "utc": "America - Boise (UTC -06:00)"
  },
  {
    "name": "America/Buenos_Aires",
    "utc": "America - Buenos Aires (UTC -03:00)"
  },
  {
    "name": "America/Cambridge_Bay",
    "utc": "America - Cambridge Bay (UTC -06:00)"
  },
  {
    "name": "America/Campo_Grande",
    "utc": "America - Campo Grande (UTC -04:00)"
  },
  {
    "name": "America/Cancun",
    "utc": "America - Cancun (UTC -05:00)"
  },
  {
    "name": "America/Caracas",
    "utc": "America - Caracas (UTC -04:00)"
  },
  {
    "name": "America/Catamarca",
    "utc": "America - Catamarca (UTC -03:00)"
  },
  {
    "name": "America/Cayenne",
    "utc": "America - Cayenne (UTC -03:00)"
  },
  {
    "name": "America/Cayman",
    "utc": "America - Cayman (UTC -05:00)"
  },
  {
    "name": "America/Chicago",
    "utc": "America - Chicago (UTC -05:00)"
  },
  {
    "name": "America/Chihuahua",
    "utc": "America - Chihuahua (UTC -06:00)"
  },
  {
    "name": "America/Ciudad_Juarez",
    "utc": "America - Ciudad Juarez (UTC -06:00)"
  },
  {
    "name": "America/Coral_Harbour",
    "utc": "America - Coral Harbour (UTC -05:00)"
  },
  {
    "name": "America/Cordoba",
    "utc": "America - Cordoba (UTC -03:00)"
  },
  {
    "name": "America/Costa_Rica",
    "utc": "America - Costa Rica (UTC -06:00)"
  },
  {
    "name": "America/Coyhaique",
    "utc": "America - Coyhaique (UTC -03:00)"
  },
  {
    "name": "America/Creston",
    "utc": "America - Creston (UTC -07:00)"
  },
  {
    "name": "America/Cuiaba",
    "utc": "America - Cuiaba (UTC -04:00)"
  },
  {
    "name": "America/Curacao",
    "utc": "America - Curacao (UTC -04:00)"
  },
  {
    "name": "America/Danmarkshavn",
    "utc": "America - Danmarkshavn (UTC +00:00)"
  },
  {
    "name": "America/Dawson",
    "utc": "America - Dawson (UTC -07:00)"
  },
  {
    "name": "America/Dawson_Creek",
    "utc": "America - Dawson Creek (UTC -07:00)"
  },
  {
    "name": "America/Denver",
    "utc": "America - Denver (UTC -06:00)"
  },
  {
    "name": "America/Detroit",
    "utc": "America - Detroit (UTC -04:00)"
  },
  {
    "name": "America/Dominica",
    "utc": "America - Dominica (UTC -04:00)"
  },
  {
    "name": "America/Edmonton",
    "utc": "America - Edmonton (UTC -06:00)"
  },
  {
    "name": "America/Eirunepe",
    "utc": "America - Eirunepe (UTC -05:00)"
  },
  {
    "name": "America/El_Salvador",
    "utc": "America - El Salvador (UTC -06:00)"
  },
  {
    "name": "America/Ensenada",
    "utc": "America - Ensenada (UTC -07:00)"
  },
  {
    "name": "America/Fort_Nelson",
    "utc": "America - Fort Nelson (UTC -07:00)"
  },
  {
    "name": "America/Fort_Wayne",
    "utc": "America - Fort Wayne (UTC -04:00)"
  },
  {
    "name": "America/Fortaleza",
    "utc": "America - Fortaleza (UTC -03:00)"
  },
  {
    "name": "America/Glace_Bay",
    "utc": "America - Glace Bay (UTC -03:00)"
  },
  {
    "name": "America/Godthab",
    "utc": "America - Godthab (UTC -01:00)"
  },
  {
    "name": "America/Goose_Bay",
    "utc": "America - Goose Bay (UTC -03:00)"
  },
  {
    "name": "America/Grand_Turk",
    "utc": "America - Grand Turk (UTC -04:00)"
  },
  {
    "name": "America/Grenada",
    "utc": "America - Grenada (UTC -04:00)"
  },
  {
    "name": "America/Guadeloupe",
    "utc": "America - Guadeloupe (UTC -04:00)"
  },
  {
    "name": "America/Guatemala",
    "utc": "America - Guatemala (UTC -06:00)"
  },
  {
    "name": "America/Guayaquil",
    "utc": "America - Guayaquil (UTC -05:00)"
  },
  {
    "name": "America/Guyana",
    "utc": "America - Guyana (UTC -04:00)"
  },
  {
    "name": "America/Halifax",
    "utc": "America - Halifax (UTC -03:00)"
  },
  {
    "name": "America/Havana",
    "utc": "America - Havana (UTC -04:00)"
  },
  {
    "name": "America/Hermosillo",
    "utc": "America - Hermosillo (UTC -07:00)"
  },
  {
    "name": "America/Indiana/Indianapolis",
    "utc": "Indiana - Indianapolis (UTC -04:00)"
  },
  {
    "name": "America/Indiana/Knox",
    "utc": "Indiana - Knox (UTC -05:00)"
  },
  {
    "name": "America/Indiana/Marengo",
    "utc": "Indiana - Marengo (UTC -04:00)"
  },
  {
    "name": "America/Indiana/Petersburg",
    "utc": "Indiana - Petersburg (UTC -04:00)"
  },
  {
    "name": "America/Indiana/Tell_City",
    "utc": "Indiana - Tell City (UTC -05:00)"
  },
  {
    "name": "America/Indiana/Vevay",
    "utc": "Indiana - Vevay (UTC -04:00)"
  },
  {
    "name": "America/Indiana/Vincennes",
    "utc": "Indiana - Vincennes (UTC -04:00)"
  },
  {
    "name": "America/Indiana/Winamac",
    "utc": "Indiana - Winamac (UTC -04:00)"
  },
  {
    "name": "America/Indianapolis",
    "utc": "America - Indianapolis (UTC -04:00)"
  },
  {
    "name": "America/Inuvik",
    "utc": "America - Inuvik (UTC -06:00)"
  },
  {
    "name": "America/Iqaluit",
    "utc": "America - Iqaluit (UTC -04:00)"
  },
  {
    "name": "America/Jamaica",
    "utc": "America - Jamaica (UTC -05:00)"
  },
  {
    "name": "America/Jujuy",
    "utc": "America - Jujuy (UTC -03:00)"
  },
  {
    "name": "America/Juneau",
    "utc": "America - Juneau (UTC -08:00)"
  },
  {
    "name": "America/Kentucky/Louisville",
    "utc": "Kentucky - Louisville (UTC -04:00)"
  },
  {
    "name": "America/Kentucky/Monticello",
    "utc": "Kentucky - Monticello (UTC -04:00)"
  },
  {
    "name": "America/Knox_IN",
    "utc": "America - Knox IN (UTC -05:00)"
  },
  {
    "name": "America/Kralendijk",
    "utc": "America - Kralendijk (UTC -04:00)"
  },
  {
    "name": "America/La_Paz",
    "utc": "America - La Paz (UTC -04:00)"
  },
  {
    "name": "America/Lima",
    "utc": "America - Lima (UTC -05:00)"
  },
  {
    "name": "America/Los_Angeles",
    "utc": "America - Los Angeles (UTC -07:00)"
  },
  {
    "name": "America/Louisville",
    "utc": "America - Louisville (UTC -04:00)"
  },
  {
    "name": "America/Lower_Princes",
    "utc": "America - Lower Princes (UTC -04:00)"
  },
  {
    "name": "America/Maceio",
    "utc": "America - Maceio (UTC -03:00)"
  },
  {
    "name": "America/Managua",
    "utc": "America - Managua (UTC -06:00)"
  },
  {
    "name": "America/Manaus",
    "utc": "America - Manaus (UTC -04:00)"
  },
  {
    "name": "America/Marigot",
    "utc": "America - Marigot (UTC -04:00)"
  },
  {
    "name": "America/Martinique",
    "utc": "America - Martinique (UTC -04:00)"
  },
  {
    "name": "America/Matamoros",
    "utc": "America - Matamoros (UTC -05:00)"
  },
  {
    "name": "America/Mazatlan",
    "utc": "America - Mazatlan (UTC -07:00)"
  },
  {
    "name": "America/Mendoza",
    "utc": "America - Mendoza (UTC -03:00)"
  },
  {
    "name": "America/Menominee",
    "utc": "America - Menominee (UTC -05:00)"
  },
  {
    "name": "America/Merida",
    "utc": "America - Merida (UTC -06:00)"
  },
  {
    "name": "America/Metlakatla",
    "utc": "America - Metlakatla (UTC -08:00)"
  },
  {
    "name": "America/Mexico_City",
    "utc": "America - Mexico City (UTC -06:00)"
  },
  {
    "name": "America/Miquelon",
    "utc": "America - Miquelon (UTC -02:00)"
  },
  {
    "name": "America/Moncton",
    "utc": "America - Moncton (UTC -03:00)"
  },
  {
    "name": "America/Monterrey",
    "utc": "America - Monterrey (UTC -06:00)"
  },
  {
    "name": "America/Montevideo",
    "utc": "America - Montevideo (UTC -03:00)"
  },
  {
    "name": "America/Montreal",
    "utc": "America - Montreal (UTC -04:00)"
  },
  {
    "name": "America/Montserrat",
    "utc": "America - Montserrat (UTC -04:00)"
  },
  {
    "name": "America/Nassau",
    "utc": "America - Nassau (UTC -04:00)"
  },
  {
    "name": "America/New_York",
    "utc": "America - New York (UTC -04:00)"
  },
  {
    "name": "America/Nipigon",
    "utc": "America - Nipigon (UTC -04:00)"
  },
  {
    "name": "America/Nome",
    "utc": "America - Nome (UTC -08:00)"
  },
  {
    "name": "America/Noronha",
    "utc": "America - Noronha (UTC -02:00)"
  },
  {
    "name": "America/North_Dakota/Beulah",
    "utc": "North_Dakota - Beulah (UTC -05:00)"
  },
  {
    "name": "America/North_Dakota/Center",
    "utc": "North_Dakota - Center (UTC -05:00)"
  },
  {
    "name": "America/North_Dakota/New_Salem",
    "utc": "North_Dakota - New Salem (UTC -05:00)"
  },
  {
    "name": "America/Nuuk",
    "utc": "America - Nuuk (UTC -01:00)"
  },
  {
    "name": "America/Ojinaga",
    "utc": "America - Ojinaga (UTC -05:00)"
  },
  {
    "name": "America/Panama",
    "utc": "America - Panama (UTC -05:00)"
  },
  {
    "name": "America/Pangnirtung",
    "utc": "America - Pangnirtung (UTC -04:00)"
  },
  {
    "name": "America/Paramaribo",
    "utc": "America - Paramaribo (UTC -03:00)"
  },
  {
    "name": "America/Phoenix",
    "utc": "America - Phoenix (UTC -07:00)"
  },
  {
    "name": "America/Port-au-Prince",
    "utc": "America - Port-au-Prince (UTC -04:00)"
  },
  {
    "name": "America/Port_of_Spain",
    "utc": "America - Port of Spain (UTC -04:00)"
  },
  {
    "name": "America/Porto_Acre",
    "utc": "America - Porto Acre (UTC -05:00)"
  },
  {
    "name": "America/Porto_Velho",
    "utc": "America - Porto Velho (UTC -04:00)"
  },
  {
    "name": "America/Puerto_Rico",
    "utc": "America - Puerto Rico (UTC -04:00)"
  },
  {
    "name": "America/Punta_Arenas",
    "utc": "America - Punta Arenas (UTC -03:00)"
  },
  {
    "name": "America/Rainy_River",
    "utc": "America - Rainy River (UTC -05:00)"
  },
  {
    "name": "America/Rankin_Inlet",
    "utc": "America - Rankin Inlet (UTC -05:00)"
  },
  {
    "name": "America/Recife",
    "utc": "America - Recife (UTC -03:00)"
  },
  {
    "name": "America/Regina",
    "utc": "America - Regina (UTC -06:00)"
  },
  {
    "name": "America/Resolute",
    "utc": "America - Resolute (UTC -05:00)"
  },
  {
    "name": "America/Rio_Branco",
    "utc": "America - Rio Branco (UTC -05:00)"
  },
  {
    "name": "America/Rosario",
    "utc": "America - Rosario (UTC -03:00)"
  },
  {
    "name": "America/Santa_Isabel",
    "utc": "America - Santa Isabel (UTC -07:00)"
  },
  {
    "name": "America/Santarem",
    "utc": "America - Santarem (UTC -03:00)"
  },
  {
    "name": "America/Santiago",
    "utc": "America - Santiago (UTC -04:00)"
  },
  {
    "name": "America/Santo_Domingo",
    "utc": "America - Santo Domingo (UTC -04:00)"
  },
  {
    "name": "America/Sao_Paulo",
    "utc": "America - Sao Paulo (UTC -03:00)"
  },
  {
    "name": "America/Scoresbysund",
    "utc": "America - Scoresbysund (UTC -01:00)"
  },
  {
    "name": "America/Shiprock",
    "utc": "America - Shiprock (UTC -06:00)"
  },
  {
    "name": "America/Sitka",
    "utc": "America - Sitka (UTC -08:00)"
  },
  {
    "name": "America/St_Barthelemy",
    "utc": "America - St Barthelemy (UTC -04:00)"
  },
  {
    "name": "America/St_Johns",
    "utc": "America - St Johns (UTC -03:30)"
  },
  {
    "name": "America/St_Kitts",
    "utc": "America - St Kitts (UTC -04:00)"
  },
  {
    "name": "America/St_Lucia",
    "utc": "America - St Lucia (UTC -04:00)"
  },
  {
    "name": "America/St_Thomas",
    "utc": "America - St Thomas (UTC -04:00)"
  },
  {
    "name": "America/St_Vincent",
    "utc": "America - St Vincent (UTC -04:00)"
  },
  {
    "name": "America/Swift_Current",
    "utc": "America - Swift Current (UTC -06:00)"
  },
  {
    "name": "America/Tegucigalpa",
    "utc": "America - Tegucigalpa (UTC -06:00)"
  },
  {
    "name": "America/Thule",
    "utc": "America - Thule (UTC -03:00)"
  },
  {
    "name": "America/Thunder_Bay",
    "utc": "America - Thunder Bay (UTC -04:00)"
  },
  {
    "name": "America/Tijuana",
    "utc": "America - Tijuana (UTC -07:00)"
  },
  {
    "name": "America/Toronto",
    "utc": "America - Toronto (UTC -04:00)"
  },
  {
    "name": "America/Tortola",
    "utc": "America - Tortola (UTC -04:00)"
  },
  {
    "name": "America/Vancouver",
    "utc": "America - Vancouver (UTC -07:00)"
  },
  {
    "name": "America/Virgin",
    "utc": "America - Virgin (UTC -04:00)"
  },
  {
    "name": "America/Whitehorse",
    "utc": "America - Whitehorse (UTC -07:00)"
  },
  {
    "name": "America/Winnipeg",
    "utc": "America - Winnipeg (UTC -05:00)"
  },
  {
    "name": "America/Yakutat",
    "utc": "America - Yakutat (UTC -08:00)"
  },
  {
    "name": "America/Yellowknife",
    "utc": "America - Yellowknife (UTC -06:00)"
  },
  {
    "name": "Antarctica/Casey",
    "utc": "Antarctica - Casey (UTC +08:00)"
  },
  {
    "name": "Antarctica/Davis",
    "utc": "Antarctica - Davis (UTC +07:00)"
  },
  {
    "name": "Antarctica/DumontDUrville",
    "utc": "Antarctica - DumontDUrville (UTC +10:00)"
  },
  {
    "name": "Antarctica/Macquarie",
    "utc": "Antarctica - Macquarie (UTC +10:00)"
  },
  {
    "name": "Antarctica/Mawson",
    "utc": "Antarctica - Mawson (UTC +05:00)"
  },
  {
    "name": "Antarctica/McMurdo",
    "utc": "Antarctica - McMurdo (UTC +12:00)"
  },
  {
    "name": "Antarctica/Palmer",
    "utc": "Antarctica - Palmer (UTC -03:00)"
  },
  {
    "name": "Antarctica/Rothera",
    "utc": "Antarctica - Rothera (UTC -03:00)"
  },
  {
    "name": "Antarctica/South_Pole",
    "utc": "Antarctica - South Pole (UTC +12:00)"
  },
  {
    "name": "Antarctica/Syowa",
    "utc": "Antarctica - Syowa (UTC +03:00)"
  },
  {
    "name": "Antarctica/Troll",
    "utc": "Antarctica - Troll (UTC +02:00)"
  },
  {
    "name": "Antarctica/Vostok",
    "utc": "Antarctica - Vostok (UTC +05:00)"
  },
  {
    "name": "Arctic/Longyearbyen",
    "utc": "Arctic - Longyearbyen (UTC +02:00)"
  },
  {
    "name": "Asia/Aden",
    "utc": "Asia - Aden (UTC +03:00)"
  },
  {
    "name": "Asia/Almaty",
    "utc": "Asia - Almaty (UTC +05:00)"
  },
  {
    "name": "Asia/Amman",
    "utc": "Asia - Amman (UTC +03:00)"
  },
  {
    "name": "Asia/Anadyr",
    "utc": "Asia - Anadyr (UTC +12:00)"
  },
  {
    "name": "Asia/Aqtau",
    "utc": "Asia - Aqtau (UTC +05:00)"
  },
  {
    "name": "Asia/Aqtobe",
    "utc": "Asia - Aqtobe (UTC +05:00)"
  },
  {
    "name": "Asia/Ashgabat",
    "utc": "Asia - Ashgabat (UTC +05:00)"
  },
  {
    "name": "Asia/Ashkhabad",
    "utc": "Asia - Ashkhabad (UTC +05:00)"
  },
  {
    "name": "Asia/Atyrau",
    "utc": "Asia - Atyrau (UTC +05:00)"
  },
  {
    "name": "Asia/Baghdad",
    "utc": "Asia - Baghdad (UTC +03:00)"
  },
  {
    "name": "Asia/Bahrain",
    "utc": "Asia - Bahrain (UTC +03:00)"
  },
  {
    "name": "Asia/Baku",
    "utc": "Asia - Baku (UTC +04:00)"
  },
  {
    "name": "Asia/Bangkok",
    "utc": "Asia - Bangkok (UTC +07:00)"
  },
  {
    "name": "Asia/Barnaul",
    "utc": "Asia - Barnaul (UTC +07:00)"
  },
  {
    "name": "Asia/Beirut",
    "utc": "Asia - Beirut (UTC +03:00)"
  },
  {
    "name": "Asia/Bishkek",
    "utc": "Asia - Bishkek (UTC +06:00)"
  },
  {
    "name": "Asia/Brunei",
    "utc": "Asia - Brunei (UTC +08:00)"
  },
  {
    "name": "Asia/Calcutta",
    "utc": "Asia - Calcutta (UTC +05:30)"
  },
  {
    "name": "Asia/Chita",
    "utc": "Asia - Chita (UTC +09:00)"
  },
  {
    "name": "Asia/Choibalsan",
    "utc": "Asia - Choibalsan (UTC +08:00)"
  },
  {
    "name": "Asia/Chongqing",
    "utc": "Asia - Chongqing (UTC +08:00)"
  },
  {
    "name": "Asia/Chungking",
    "utc": "Asia - Chungking (UTC +08:00)"
  },
  {
    "name": "Asia/Colombo",
    "utc": "Asia - Colombo (UTC +05:30)"
  },
  {
    "name": "Asia/Dacca",
    "utc": "Asia - Dacca (UTC +06:00)"
  },
  {
    "name": "Asia/Damascus",
    "utc": "Asia - Damascus (UTC +03:00)"
  },
  {
    "name": "Asia/Dhaka",
    "utc": "Asia - Dhaka (UTC +06:00)"
  },
  {
    "name": "Asia/Dili",
    "utc": "Asia - Dili (UTC +09:00)"
  },
  {
    "name": "Asia/Dubai",
    "utc": "Asia - Dubai (UTC +04:00)"
  },
  {
    "name": "Asia/Dushanbe",
    "utc": "Asia - Dushanbe (UTC +05:00)"
  },
  {
    "name": "Asia/Famagusta",
    "utc": "Asia - Famagusta (UTC +03:00)"
  },
  {
    "name": "Asia/Gaza",
    "utc": "Asia - Gaza (UTC +03:00)"
  },
  {
    "name": "Asia/Harbin",
    "utc": "Asia - Harbin (UTC +08:00)"
  },
  {
    "name": "Asia/Hebron",
    "utc": "Asia - Hebron (UTC +03:00)"
  },
  {
    "name": "Asia/Ho_Chi_Minh",
    "utc": "Asia - Ho Chi Minh (UTC +07:00)"
  },
  {
    "name": "Asia/Hong_Kong",
    "utc": "Asia - Hong Kong (UTC +08:00)"
  },
  {
    "name": "Asia/Hovd",
    "utc": "Asia - Hovd (UTC +07:00)"
  },
  {
    "name": "Asia/Irkutsk",
    "utc": "Asia - Irkutsk (UTC +08:00)"
  },
  {
    "name": "Asia/Istanbul",
    "utc": "Asia - Istanbul (UTC +03:00)"
  },
  {
    "name": "Asia/Jakarta",
    "utc": "Asia - Jakarta (UTC +07:00)"
  },
  {
    "name": "Asia/Jayapura",
    "utc": "Asia - Jayapura (UTC +09:00)"
  },
  {
    "name": "Asia/Jerusalem",
    "utc": "Asia - Jerusalem (UTC +03:00)"
  },
  {
    "name": "Asia/Kabul",
    "utc": "Asia - Kabul (UTC +04:30)"
  },
  {
    "name": "Asia/Kamchatka",
    "utc": "Asia - Kamchatka (UTC +12:00)"
  },
  {
    "name": "Asia/Karachi",
    "utc": "Asia - Karachi (UTC +05:00)"
  },
  {
    "name": "Asia/Kashgar",
    "utc": "Asia - Kashgar (UTC +06:00)"
  },
  {
    "name": "Asia/Kathmandu",
    "utc": "Asia - Kathmandu (UTC +05:45)"
  },
  {
    "name": "Asia/Katmandu",
    "utc": "Asia - Katmandu (UTC +05:45)"
  },
  {
    "name": "Asia/Khandyga",
    "utc": "Asia - Khandyga (UTC +09:00)"
  },
  {
    "name": "Asia/Kolkata",
    "utc": "Asia - Kolkata (UTC +05:30)"
  },
  {
    "name": "Asia/Krasnoyarsk",
    "utc": "Asia - Krasnoyarsk (UTC +07:00)"
  },
  {
    "name": "Asia/Kuala_Lumpur",
    "utc": "Asia - Kuala Lumpur (UTC +08:00)"
  },
  {
    "name": "Asia/Kuching",
    "utc": "Asia - Kuching (UTC +08:00)"
  },
  {
    "name": "Asia/Kuwait",
    "utc": "Asia - Kuwait (UTC +03:00)"
  },
  {
    "name": "Asia/Macao",
    "utc": "Asia - Macao (UTC +08:00)"
  },
  {
    "name": "Asia/Macau",
    "utc": "Asia - Macau (UTC +08:00)"
  },
  {
    "name": "Asia/Magadan",
    "utc": "Asia - Magadan (UTC +11:00)"
  },
  {
    "name": "Asia/Makassar",
    "utc": "Asia - Makassar (UTC +08:00)"
  },
  {
    "name": "Asia/Manila",
    "utc": "Asia - Manila (UTC +08:00)"
  },
  {
    "name": "Asia/Muscat",
    "utc": "Asia - Muscat (UTC +04:00)"
  },
  {
    "name": "Asia/Nicosia",
    "utc": "Asia - Nicosia (UTC +03:00)"
  },
  {
    "name": "Asia/Novokuznetsk",
    "utc": "Asia - Novokuznetsk (UTC +07:00)"
  },
  {
    "name": "Asia/Novosibirsk",
    "utc": "Asia - Novosibirsk (UTC +07:00)"
  },
  {
    "name": "Asia/Omsk",
    "utc": "Asia - Omsk (UTC +06:00)"
  },
  {
    "name": "Asia/Oral",
    "utc": "Asia - Oral (UTC +05:00)"
  },
  {
    "name": "Asia/Phnom_Penh",
    "utc": "Asia - Phnom Penh (UTC +07:00)"
  },
  {
    "name": "Asia/Pontianak",
    "utc": "Asia - Pontianak (UTC +07:00)"
  },
  {
    "name": "Asia/Pyongyang",
    "utc": "Asia - Pyongyang (UTC +09:00)"
  },
  {
    "name": "Asia/Qatar",
    "utc": "Asia - Qatar (UTC +03:00)"
  },
  {
    "name": "Asia/Qostanay",
    "utc": "Asia - Qostanay (UTC +05:00)"
  },
  {
    "name": "Asia/Qyzylorda",
    "utc": "Asia - Qyzylorda (UTC +05:00)"
  },
  {
    "name": "Asia/Rangoon",
    "utc": "Asia - Rangoon (UTC +06:30)"
  },
  {
    "name": "Asia/Riyadh",
    "utc": "Asia - Riyadh (UTC +03:00)"
  },
  {
    "name": "Asia/Saigon",
    "utc": "Asia - Saigon (UTC +07:00)"
  },
  {
    "name": "Asia/Sakhalin",
    "utc": "Asia - Sakhalin (UTC +11:00)"
  },
  {
    "name": "Asia/Samarkand",
    "utc": "Asia - Samarkand (UTC +05:00)"
  },
  {
    "name": "Asia/Seoul",
    "utc": "Asia - Seoul (UTC +09:00)"
  },
  {
    "name": "Asia/Shanghai",
    "utc": "Asia - Shanghai (UTC +08:00)"
  },
  {
    "name": "Asia/Singapore",
    "utc": "Asia - Singapore (UTC +08:00)"
  },
  {
    "name": "Asia/Srednekolymsk",
    "utc": "Asia - Srednekolymsk (UTC +11:00)"
  },
  {
    "name": "Asia/Taipei",
    "utc": "Asia - Taipei (UTC +08:00)"
  },
  {
    "name": "Asia/Tashkent",
    "utc": "Asia - Tashkent (UTC +05:00)"
  },
  {
    "name": "Asia/Tbilisi",
    "utc": "Asia - Tbilisi (UTC +04:00)"
  },
  {
    "name": "Asia/Tehran",
    "utc": "Asia - Tehran (UTC +03:30)"
  },
  {
    "name": "Asia/Tel_Aviv",
    "utc": "Asia - Tel Aviv (UTC +03:00)"
  },
  {
    "name": "Asia/Thimbu",
    "utc": "Asia - Thimbu (UTC +06:00)"
  },
  {
    "name": "Asia/Thimphu",
    "utc": "Asia - Thimphu (UTC +06:00)"
  },
  {
    "name": "Asia/Tokyo",
    "utc": "Asia - Tokyo (UTC +09:00)"
  },
  {
    "name": "Asia/Tomsk",
    "utc": "Asia - Tomsk (UTC +07:00)"
  },
  {
    "name": "Asia/Ujung_Pandang",
    "utc": "Asia - Ujung Pandang (UTC +08:00)"
  },
  {
    "name": "Asia/Ulaanbaatar",
    "utc": "Asia - Ulaanbaatar (UTC +08:00)"
  },
  {
    "name": "Asia/Ulan_Bator",
    "utc": "Asia - Ulan Bator (UTC +08:00)"
  },
  {
    "name": "Asia/Urumqi",
    "utc": "Asia - Urumqi (UTC +06:00)"
  },
  {
    "name": "Asia/Ust-Nera",
    "utc": "Asia - Ust-Nera (UTC +10:00)"
  },
  {
    "name": "Asia/Vientiane",
    "utc": "Asia - Vientiane (UTC +07:00)"
  },
  {
    "name": "Asia/Vladivostok",
    "utc": "Asia - Vladivostok (UTC +10:00)"
  },
  {
    "name": "Asia/Yakutsk",
    "utc": "Asia - Yakutsk (UTC +09:00)"
  },
  {
    "name": "Asia/Yangon",
    "utc": "Asia - Yangon (UTC +06:30)"
  },
  {
    "name": "Asia/Yekaterinburg",
    "utc": "Asia - Yekaterinburg (UTC +05:00)"
  },
  {
    "name": "Asia/Yerevan",
    "utc": "Asia - Yerevan (UTC +04:00)"
  },
  {
    "name": "Atlantic/Azores",
    "utc": "Atlantic - Azores (UTC +00:00)"
  },
  {
    "name": "Atlantic/Bermuda",
    "utc": "Atlantic - Bermuda (UTC -03:00)"
  },
  {
    "name": "Atlantic/Canary",
    "utc": "Atlantic - Canary (UTC +01:00)"
  },
  {
    "name": "Atlantic/Cape_Verde",
    "utc": "Atlantic - Cape Verde (UTC -01:00)"
  },
  {
    "name": "Atlantic/Faeroe",
    "utc": "Atlantic - Faeroe (UTC +01:00)"
  },
  {
    "name": "Atlantic/Faroe",
    "utc": "Atlantic - Faroe (UTC +01:00)"
  },
  {
    "name": "Atlantic/Jan_Mayen",
    "utc": "Atlantic - Jan Mayen (UTC +02:00)"
  },
  {
    "name": "Atlantic/Madeira",
    "utc": "Atlantic - Madeira (UTC +01:00)"
  },
  {
    "name": "Atlantic/Reykjavik",
    "utc": "Atlantic - Reykjavik (UTC +00:00)"
  },
  {
    "name": "Atlantic/South_Georgia",
    "utc": "Atlantic - South Georgia (UTC -02:00)"
  },
  {
    "name": "Atlantic/St_Helena",
    "utc": "Atlantic - St Helena (UTC +00:00)"
  },
  {
    "name": "Atlantic/Stanley",
    "utc": "Atlantic - Stanley (UTC -03:00)"
  },
  {
    "name": "Australia/ACT",
    "utc": "Australia - ACT (UTC +10:00)"
  },
  {
    "name": "Australia/Adelaide",
    "utc": "Australia - Adelaide (UTC +09:30)"
  },
  {
    "name": "Australia/Brisbane",
    "utc": "Australia - Brisbane (UTC +10:00)"
  },
  {
    "name": "Australia/Broken_Hill",
    "utc": "Australia - Broken Hill (UTC +09:30)"
  },
  {
    "name": "Australia/Canberra",
    "utc": "Australia - Canberra (UTC +10:00)"
  },
  {
    "name": "Australia/Currie",
    "utc": "Australia - Currie (UTC +10:00)"
  },
  {
    "name": "Australia/Darwin",
    "utc": "Australia - Darwin (UTC +09:30)"
  },
  {
    "name": "Australia/Eucla",
    "utc": "Australia - Eucla (UTC +08:45)"
  },
  {
    "name": "Australia/Hobart",
    "utc": "Australia - Hobart (UTC +10:00)"
  },
  {
    "name": "Australia/LHI",
    "utc": "Australia - LHI (UTC +10:30)"
  },
  {
    "name": "Australia/Lindeman",
    "utc": "Australia - Lindeman (UTC +10:00)"
  },
  {
    "name": "Australia/Lord_Howe",
    "utc": "Australia - Lord Howe (UTC +10:30)"
  },
  {
    "name": "Australia/Melbourne",
    "utc": "Australia - Melbourne (UTC +10:00)"
  },
  {
    "name": "Australia/NSW",
    "utc": "Australia - NSW (UTC +10:00)"
  },
  {
    "name": "Australia/North",
    "utc": "Australia - North (UTC +09:30)"
  },
  {
    "name": "Australia/Perth",
    "utc": "Australia - Perth (UTC +08:00)"
  },
  {
    "name": "Australia/Queensland",
    "utc": "Australia - Queensland (UTC +10:00)"
  },
  {
    "name": "Australia/South",
    "utc": "Australia - South (UTC +09:30)"
  },
  {
    "name": "Australia/Sydney",
    "utc": "Australia - Sydney (UTC +10:00)"
  },
  {
    "name": "Australia/Tasmania",
    "utc": "Australia - Tasmania (UTC +10:00)"
  },
  {
    "name": "Australia/Victoria",
    "utc": "Australia - Victoria (UTC +10:00)"
  },
  {
    "name": "Australia/West",
    "utc": "Australia - West (UTC +08:00)"
  },
  {
    "name": "Australia/Yancowinna",
    "utc": "Australia - Yancowinna (UTC +09:30)"
  },
  {
    "name": "Brazil/Acre",
    "utc": "Brazil - Acre (UTC -05:00)"
  },
  {
    "name": "Brazil/DeNoronha",
    "utc": "Brazil - DeNoronha (UTC -02:00)"
  },
  {
    "name": "Brazil/East",
    "utc": "Brazil - East (UTC -03:00)"
  },
  {
    "name": "Brazil/West",
    "utc": "Brazil - West (UTC -04:00)"
  },
  {
    "name": "CET",
    "utc": "CET (UTC +02:00)"
  },
  {
    "name": "CST6CDT",
    "utc": "CST6CDT (UTC -05:00)"
  },
  {
    "name": "Canada/Atlantic",
    "utc": "Canada - Atlantic (UTC -03:00)"
  },
  {
    "name": "Canada/Central",
    "utc": "Canada - Central (UTC -05:00)"
  },
  {
    "name": "Canada/Eastern",
    "utc": "Canada - Eastern (UTC -04:00)"
  },
  {
    "name": "Canada/Mountain",
    "utc": "Canada - Mountain (UTC -06:00)"
  },
  {
    "name": "Canada/Newfoundland",
    "utc": "Canada - Newfoundland (UTC -03:30)"
  },
  {
    "name": "Canada/Pacific",
    "utc": "Canada - Pacific (UTC -07:00)"
  },
  {
    "name": "Canada/Saskatchewan",
    "utc": "Canada - Saskatchewan (UTC -06:00)"
  },
  {
    "name": "Canada/Yukon",
    "utc": "Canada - Yukon (UTC -07:00)"
  },
  {
    "name": "Chile/Continental",
    "utc": "Chile - Continental (UTC -04:00)"
  },
  {
    "name": "Chile/EasterIsland",
    "utc": "Chile - EasterIsland (UTC -06:00)"
  },
  {
    "name": "Cuba",
    "utc": "Cuba (UTC -04:00)"
  },
  {
    "name": "EET",
    "utc": "EET (UTC +03:00)"
  },
  {
    "name": "EST",
    "utc": "EST (UTC -05:00)"
  },
  {
    "name": "EST5EDT",
    "utc": "EST5EDT (UTC -04:00)"
  },
  {
    "name": "Egypt",
    "utc": "Egypt (UTC +03:00)"
  },
  {
    "name": "Eire",
    "utc": "Eire (UTC +01:00)"
  },
  {
    "name": "Etc/GMT",
    "utc": "Etc - GMT (UTC +00:00)"
  },
  {
    "name": "Etc/GMT+0",
    "utc": "Etc - GMT+0 (UTC +00:00)"
  },
  {
    "name": "Etc/GMT+1",
    "utc": "Etc - GMT+1 (UTC -01:00)"
  },
  {
    "name": "Etc/GMT+10",
    "utc": "Etc - GMT+10 (UTC -10:00)"
  },
  {
    "name": "Etc/GMT+11",
    "utc": "Etc - GMT+11 (UTC -11:00)"
  },
  {
    "name": "Etc/GMT+12",
    "utc": "Etc - GMT+12 (UTC -12:00)"
  },
  {
    "name": "Etc/GMT+2",
    "utc": "Etc - GMT+2 (UTC -02:00)"
  },
  {
    "name": "Etc/GMT+3",
    "utc": "Etc - GMT+3 (UTC -03:00)"
  },
  {
    "name": "Etc/GMT+4",
    "utc": "Etc - GMT+4 (UTC -04:00)"
  },
  {
    "name": "Etc/GMT+5",
    "utc": "Etc - GMT+5 (UTC -05:00)"
  },
  {
    "name": "Etc/GMT+6",
    "utc": "Etc - GMT+6 (UTC -06:00)"
  },
  {
    "name": "Etc/GMT+7",
    "utc": "Etc - GMT+7 (UTC -07:00)"
  },
  {
    "name": "Etc/GMT+8",
    "utc": "Etc - GMT+8 (UTC -08:00)"
  },
  {
    "name": "Etc/GMT+9",
    "utc": "Etc - GMT+9 (UTC -09:00)"
  },
  {
    "name": "Etc/GMT-0",
    "utc": "Etc - GMT-0 (UTC +00:00)"
  },
  {
    "name": "Etc/GMT-1",
    "utc": "Etc - GMT-1 (UTC +01:00)"
  },
  {
    "name": "Etc/GMT-10",
    "utc": "Etc - GMT-10 (UTC +10:00)"
  },
  {
    "name": "Etc/GMT-11",
    "utc": "Etc - GMT-11 (UTC +11:00)"
  },
  {
    "name": "Etc/GMT-12",
    "utc": "Etc - GMT-12 (UTC +12:00)"
  },
  {
    "name": "Etc/GMT-13",
    "utc": "Etc - GMT-13 (UTC +13:00)"
  },
  {
    "name": "Etc/GMT-14",
    "utc": "Etc - GMT-14 (UTC +14:00)"
  },
  {
    "name": "Etc/GMT-2",
    "utc": "Etc - GMT-2 (UTC +02:00)"
  },
  {
    "name": "Etc/GMT-3",
    "utc": "Etc - GMT-3 (UTC +03:00)"
  },
  {
    "name": "Etc/GMT-4",
    "utc": "Etc - GMT-4 (UTC +04:00)"
  },
  {
    "name": "Etc/GMT-5",
    "utc": "Etc - GMT-5 (UTC +05:00)"
  },
  {
    "name": "Etc/GMT-6",
    "utc": "Etc - GMT-6 (UTC +06:00)"
  },
  {
    "name": "Etc/GMT-7",
    "utc": "Etc - GMT-7 (UTC +07:00)"
  },
  {
    "name": "Etc/GMT-8",
    "utc": "Etc - GMT-8 (UTC +08:00)"
  },
  {
    "name": "Etc/GMT-9",
    "utc": "Etc - GMT-9 (UTC +09:00)"
  },
  {
    "name": "Etc/GMT0",
    "utc": "Etc - GMT0 (UTC +00:00)"
  },
  {
    "name": "Etc/Greenwich",
    "utc": "Etc - Greenwich (UTC +00:00)"
  },
  {
    "name": "Etc/UCT",
    "utc": "Etc - UCT (UTC +00:00)"
  },
  {
    "name": "Etc/UTC",
    "utc": "Etc - UTC (UTC +00:00)"
  },
  {
    "name": "Etc/Universal",
    "utc": "Etc - Universal (UTC +00:00)"
  },
  {
    "name": "Etc/Zulu",
    "utc": "Etc - Zulu (UTC +00:00)"
  },
  {
    "name": "Europe/Amsterdam",
    "utc": "Europe - Amsterdam (UTC +02:00)"
  },
  {
    "name": "Europe/Andorra",
    "utc": "Europe - Andorra (UTC +02:00)"
  },
  {
    "name": "Europe/Astrakhan",
    "utc": "Europe - Astrakhan (UTC +04:00)"
  },
  {
    "name": "Europe/Athens",
    "utc": "Europe - Athens (UTC +03:00)"
  },
  {
    "name": "Europe/Belfast",
    "utc": "Europe - Belfast (UTC +01:00)"
  },
  {
    "name": "Europe/Belgrade",
    "utc": "Europe - Belgrade (UTC +02:00)"
  },
  {
    "name": "Europe/Berlin",
    "utc": "Europe - Berlin (UTC +02:00)"
  },
  {
    "name": "Europe/Bratislava",
    "utc": "Europe - Bratislava (UTC +02:00)"
  },
  {
    "name": "Europe/Brussels",
    "utc": "Europe - Brussels (UTC +02:00)"
  },
  {
    "name": "Europe/Bucharest",
    "utc": "Europe - Bucharest (UTC +03:00)"
  },
  {
    "name": "Europe/Budapest",
    "utc": "Europe - Budapest (UTC +02:00)"
  },
  {
    "name": "Europe/Busingen",
    "utc": "Europe - Busingen (UTC +02:00)"
  },
  {
    "name": "Europe/Chisinau",
    "utc": "Europe - Chisinau (UTC +03:00)"
  },
  {
    "name": "Europe/Copenhagen",
    "utc": "Europe - Copenhagen (UTC +02:00)"
  },
  {
    "name": "Europe/Dublin",
    "utc": "Europe - Dublin (UTC +01:00)"
  },
  {
    "name": "Europe/Gibraltar",
    "utc": "Europe - Gibraltar (UTC +02:00)"
  },
  {
    "name": "Europe/Guernsey",
    "utc": "Europe - Guernsey (UTC +01:00)"
  },
  {
    "name": "Europe/Helsinki",
    "utc": "Europe - Helsinki (UTC +03:00)"
  },
  {
    "name": "Europe/Isle_of_Man",
    "utc": "Europe - Isle of Man (UTC +01:00)"
  },
  {
    "name": "Europe/Istanbul",
    "utc": "Europe - Istanbul (UTC +03:00)"
  },
  {
    "name": "Europe/Jersey",
    "utc": "Europe - Jersey (UTC +01:00)"
  },
  {
    "name": "Europe/Kaliningrad",
    "utc": "Europe - Kaliningrad (UTC +02:00)"
  },
  {
    "name": "Europe/Kiev",
    "utc": "Europe - Kiev (UTC +03:00)"
  },
  {
    "name": "Europe/Kirov",
    "utc": "Europe - Kirov (UTC +03:00)"
  },
  {
    "name": "Europe/Kyiv",
    "utc": "Europe - Kyiv (UTC +03:00)"
  },
  {
    "name": "Europe/Lisbon",
    "utc": "Europe - Lisbon (UTC +01:00)"
  },
  {
    "name": "Europe/Ljubljana",
    "utc": "Europe - Ljubljana (UTC +02:00)"
  },
  {
    "name": "Europe/London",
    "utc": "Europe - London (UTC +01:00)"
  },
  {
    "name": "Europe/Luxembourg",
    "utc": "Europe - Luxembourg (UTC +02:00)"
  },
  {
    "name": "Europe/Madrid",
    "utc": "Europe - Madrid (UTC +02:00)"
  },
  {
    "name": "Europe/Malta",
    "utc": "Europe - Malta (UTC +02:00)"
  },
  {
    "name": "Europe/Mariehamn",
    "utc": "Europe - Mariehamn (UTC +03:00)"
  },
  {
    "name": "Europe/Minsk",
    "utc": "Europe - Minsk (UTC +03:00)"
  },
  {
    "name": "Europe/Monaco",
    "utc": "Europe - Monaco (UTC +02:00)"
  },
  {
    "name": "Europe/Moscow",
    "utc": "Europe - Moscow (UTC +03:00)"
  },
  {
    "name": "Europe/Nicosia",
    "utc": "Europe - Nicosia (UTC +03:00)"
  },
  {
    "name": "Europe/Oslo",
    "utc": "Europe - Oslo (UTC +02:00)"
  },
  {
    "name": "Europe/Paris",
    "utc": "Europe - Paris (UTC +02:00)"
  },
  {
    "name": "Europe/Podgorica",
    "utc": "Europe - Podgorica (UTC +02:00)"
  },
  {
    "name": "Europe/Prague",
    "utc": "Europe - Prague (UTC +02:00)"
  },
  {
    "name": "Europe/Riga",
    "utc": "Europe - Riga (UTC +03:00)"
  },
  {
    "name": "Europe/Rome",
    "utc": "Europe - Rome (UTC +02:00)"
  },
  {
    "name": "Europe/Samara",
    "utc": "Europe - Samara (UTC +04:00)"
  },
  {
    "name": "Europe/San_Marino",
    "utc": "Europe - San Marino (UTC +02:00)"
  },
  {
    "name": "Europe/Sarajevo",
    "utc": "Europe - Sarajevo (UTC +02:00)"
  },
  {
    "name": "Europe/Saratov",
    "utc": "Europe - Saratov (UTC +04:00)"
  },
  {
    "name": "Europe/Simferopol",
    "utc": "Europe - Simferopol (UTC +03:00)"
  },
  {
    "name": "Europe/Skopje",
    "utc": "Europe - Skopje (UTC +02:00)"
  },
  {
    "name": "Europe/Sofia",
    "utc": "Europe - Sofia (UTC +03:00)"
  },
  {
    "name": "Europe/Stockholm",
    "utc": "Europe - Stockholm (UTC +02:00)"
  },
  {
    "name": "Europe/Tallinn",
    "utc": "Europe - Tallinn (UTC +03:00)"
  },
  {
    "name": "Europe/Tirane",
    "utc": "Europe - Tirane (UTC +02:00)"
  },
  {
    "name": "Europe/Tiraspol",
    "utc": "Europe - Tiraspol (UTC +03:00)"
  },
  {
    "name": "Europe/Ulyanovsk",
    "utc": "Europe - Ulyanovsk (UTC +04:00)"
  },
  {
    "name": "Europe/Uzhgorod",
    "utc": "Europe - Uzhgorod (UTC +03:00)"
  },
  {
    "name": "Europe/Vaduz",
    "utc": "Europe - Vaduz (UTC +02:00)"
  },
  {
    "name": "Europe/Vatican",
    "utc": "Europe - Vatican (UTC +02:00)"
  },
  {
    "name": "Europe/Vienna",
    "utc": "Europe - Vienna (UTC +02:00)"
  },
  {
    "name": "Europe/Vilnius",
    "utc": "Europe - Vilnius (UTC +03:00)"
  },
  {
    "name": "Europe/Volgograd",
    "utc": "Europe - Volgograd (UTC +03:00)"
  },
  {
    "name": "Europe/Warsaw",
    "utc": "Europe - Warsaw (UTC +02:00)"
  },
  {
    "name": "Europe/Zagreb",
    "utc": "Europe - Zagreb (UTC +02:00)"
  },
  {
    "name": "Europe/Zaporozhye",
    "utc": "Europe - Zaporozhye (UTC +03:00)"
  },
  {
    "name": "Europe/Zurich",
    "utc": "Europe - Zurich (UTC +02:00)"
  },
  {
    "name": "GB",
    "utc": "GB (UTC +01:00)"
  },
  {
    "name": "GB-Eire",
    "utc": "GB-Eire (UTC +01:00)"
  },
  {
    "name": "GMT",
    "utc": "GMT (UTC +00:00)"
  },
  {
    "name": "GMT+0",
    "utc": "GMT+0 (UTC +00:00)"
  },
  {
    "name": "GMT-0",
    "utc": "GMT-0 (UTC +00:00)"
  },
  {
    "name": "GMT0",
    "utc": "GMT0 (UTC +00:00)"
  },
  {
    "name": "Greenwich",
    "utc": "Greenwich (UTC +00:00)"
  },
  {
    "name": "HST",
    "utc": "HST (UTC -10:00)"
  },
  {
    "name": "Hongkong",
    "utc": "Hongkong (UTC +08:00)"
  },
  {
    "name": "Iceland",
    "utc": "Iceland (UTC +00:00)"
  },
  {
    "name": "Indian/Antananarivo",
    "utc": "Indian - Antananarivo (UTC +03:00)"
  },
  {
    "name": "Indian/Chagos",
    "utc": "Indian - Chagos (UTC +06:00)"
  },
  {
    "name": "Indian/Christmas",
    "utc": "Indian - Christmas (UTC +07:00)"
  },
  {
    "name": "Indian/Cocos",
    "utc": "Indian - Cocos (UTC +06:30)"
  },
  {
    "name": "Indian/Comoro",
    "utc": "Indian - Comoro (UTC +03:00)"
  },
  {
    "name": "Indian/Kerguelen",
    "utc": "Indian - Kerguelen (UTC +05:00)"
  },
  {
    "name": "Indian/Mahe",
    "utc": "Indian - Mahe (UTC +04:00)"
  },
  {
    "name": "Indian/Maldives",
    "utc": "Indian - Maldives (UTC +05:00)"
  },
  {
    "name": "Indian/Mauritius",
    "utc": "Indian - Mauritius (UTC +04:00)"
  },
  {
    "name": "Indian/Mayotte",
    "utc": "Indian - Mayotte (UTC +03:00)"
  },
  {
    "name": "Indian/Reunion",
    "utc": "Indian - Reunion (UTC +04:00)"
  },
  {
    "name": "Iran",
    "utc": "Iran (UTC +03:30)"
  },
  {
    "name": "Israel",
    "utc": "Israel (UTC +03:00)"
  },
  {
    "name": "Jamaica",
    "utc": "Jamaica (UTC -05:00)"
  },
  {
    "name": "Japan",
    "utc": "Japan (UTC +09:00)"
  },
  {
    "name": "Kwajalein",
    "utc": "Kwajalein (UTC +12:00)"
  },
  {
    "name": "Libya",
    "utc": "Libya (UTC +02:00)"
  },
  {
    "name": "MET",
    "utc": "MET (UTC +02:00)"
  },
  {
    "name": "MST",
    "utc": "MST (UTC -07:00)"
  },
  {
    "name": "MST7MDT",
    "utc": "MST7MDT (UTC -06:00)"
  },
  {
    "name": "Mexico/BajaNorte",
    "utc": "Mexico - BajaNorte (UTC -07:00)"
  },
  {
    "name": "Mexico/BajaSur",
    "utc": "Mexico - BajaSur (UTC -07:00)"
  },
  {
    "name": "Mexico/General",
    "utc": "Mexico - General (UTC -06:00)"
  },
  {
    "name": "NZ",
    "utc": "NZ (UTC +12:00)"
  },
  {
    "name": "NZ-CHAT",
    "utc": "NZ-CHAT (UTC +12:45)"
  },
  {
    "name": "Navajo",
    "utc": "Navajo (UTC -06:00)"
  },
  {
    "name": "PRC",
    "utc": "PRC (UTC +08:00)"
  },
  {
    "name": "PST8PDT",
    "utc": "PST8PDT (UTC -07:00)"
  },
  {
    "name": "Pacific/Apia",
    "utc": "Pacific - Apia (UTC +13:00)"
  },
  {
    "name": "Pacific/Auckland",
    "utc": "Pacific - Auckland (UTC +12:00)"
  },
  {
    "name": "Pacific/Bougainville",
    "utc": "Pacific - Bougainville (UTC +11:00)"
  },
  {
    "name": "Pacific/Chatham",
    "utc": "Pacific - Chatham (UTC +12:45)"
  },
  {
    "name": "Pacific/Chuuk",
    "utc": "Pacific - Chuuk (UTC +10:00)"
  },
  {
    "name": "Pacific/Easter",
    "utc": "Pacific - Easter (UTC -06:00)"
  },
  {
    "name": "Pacific/Efate",
    "utc": "Pacific - Efate (UTC +11:00)"
  },
  {
    "name": "Pacific/Enderbury",
    "utc": "Pacific - Enderbury (UTC +13:00)"
  },
  {
    "name": "Pacific/Fakaofo",
    "utc": "Pacific - Fakaofo (UTC +13:00)"
  },
  {
    "name": "Pacific/Fiji",
    "utc": "Pacific - Fiji (UTC +12:00)"
  },
  {
    "name": "Pacific/Funafuti",
    "utc": "Pacific - Funafuti (UTC +12:00)"
  },
  {
    "name": "Pacific/Galapagos",
    "utc": "Pacific - Galapagos (UTC -06:00)"
  },
  {
    "name": "Pacific/Gambier",
    "utc": "Pacific - Gambier (UTC -09:00)"
  },
  {
    "name": "Pacific/Guadalcanal",
    "utc": "Pacific - Guadalcanal (UTC +11:00)"
  },
  {
    "name": "Pacific/Guam",
    "utc": "Pacific - Guam (UTC +10:00)"
  },
  {
    "name": "Pacific/Honolulu",
    "utc": "Pacific - Honolulu (UTC -10:00)"
  },
  {
    "name": "Pacific/Johnston",
    "utc": "Pacific - Johnston (UTC -10:00)"
  },
  {
    "name": "Pacific/Kanton",
    "utc": "Pacific - Kanton (UTC +13:00)"
  },
  {
    "name": "Pacific/Kiritimati",
    "utc": "Pacific - Kiritimati (UTC +14:00)"
  },
  {
    "name": "Pacific/Kosrae",
    "utc": "Pacific - Kosrae (UTC +11:00)"
  },
  {
    "name": "Pacific/Kwajalein",
    "utc": "Pacific - Kwajalein (UTC +12:00)"
  },
  {
    "name": "Pacific/Majuro",
    "utc": "Pacific - Majuro (UTC +12:00)"
  },
  {
    "name": "Pacific/Marquesas",
    "utc": "Pacific - Marquesas (UTC -10:30)"
  },
  {
    "name": "Pacific/Midway",
    "utc": "Pacific - Midway (UTC -11:00)"
  },
  {
    "name": "Pacific/Nauru",
    "utc": "Pacific - Nauru (UTC +12:00)"
  },
  {
    "name": "Pacific/Niue",
    "utc": "Pacific - Niue (UTC -11:00)"
  },
  {
    "name": "Pacific/Norfolk",
    "utc": "Pacific - Norfolk (UTC +11:00)"
  },
  {
    "name": "Pacific/Noumea",
    "utc": "Pacific - Noumea (UTC +11:00)"
  },
  {
    "name": "Pacific/Pago_Pago",
    "utc": "Pacific - Pago Pago (UTC -11:00)"
  },
  {
    "name": "Pacific/Palau",
    "utc": "Pacific - Palau (UTC +09:00)"
  },
  {
    "name": "Pacific/Pitcairn",
    "utc": "Pacific - Pitcairn (UTC -08:00)"
  },
  {
    "name": "Pacific/Pohnpei",
    "utc": "Pacific - Pohnpei (UTC +11:00)"
  },
  {
    "name": "Pacific/Ponape",
    "utc": "Pacific - Ponape (UTC +11:00)"
  },
  {
    "name": "Pacific/Port_Moresby",
    "utc": "Pacific - Port Moresby (UTC +10:00)"
  },
  {
    "name": "Pacific/Rarotonga",
    "utc": "Pacific - Rarotonga (UTC -10:00)"
  },
  {
    "name": "Pacific/Saipan",
    "utc": "Pacific - Saipan (UTC +10:00)"
  },
  {
    "name": "Pacific/Samoa",
    "utc": "Pacific - Samoa (UTC -11:00)"
  },
  {
    "name": "Pacific/Tahiti",
    "utc": "Pacific - Tahiti (UTC -10:00)"
  },
  {
    "name": "Pacific/Tarawa",
    "utc": "Pacific - Tarawa (UTC +12:00)"
  },
  {
    "name": "Pacific/Tongatapu",
    "utc": "Pacific - Tongatapu (UTC +13:00)"
  },
  {
    "name": "Pacific/Truk",
    "utc": "Pacific - Truk (UTC +10:00)"
  },
  {
    "name": "Pacific/Wake",
    "utc": "Pacific - Wake (UTC +12:00)"
  },
  {
    "name": "Pacific/Wallis",
    "utc": "Pacific - Wallis (UTC +12:00)"
  },
  {
    "name": "Pacific/Yap",
    "utc": "Pacific - Yap (UTC +10:00)"
  },
  {
    "name": "Poland",
    "utc": "Poland (UTC +02:00)"
  },
  {
    "name": "Portugal",
    "utc": "Portugal (UTC +01:00)"
  },
  {
    "name": "ROC",
    "utc": "ROC (UTC +08:00)"
  },
  {
    "name": "ROK",
    "utc": "ROK (UTC +09:00)"
  },
  {
    "name": "Singapore",
    "utc": "Singapore (UTC +08:00)"
  },
  {
    "name": "Turkey",
    "utc": "Turkey (UTC +03:00)"
  },
  {
    "name": "UCT",
    "utc": "UCT (UTC +00:00)"
  },
  {
    "name": "US/Alaska",
    "utc": "US - Alaska (UTC -08:00)"
  },
  {
    "name": "US/Aleutian",
    "utc": "US - Aleutian (UTC -09:00)"
  },
  {
    "name": "US/Arizona",
    "utc": "US - Arizona (UTC -07:00)"
  },
  {
    "name": "US/Central",
    "utc": "US - Central (UTC -05:00)"
  },
  {
    "name": "US/East-Indiana",
    "utc": "US - East-Indiana (UTC -04:00)"
  },
  {
    "name": "US/Eastern",
    "utc": "US - Eastern (UTC -04:00)"
  },
  {
    "name": "US/Hawaii",
    "utc": "US - Hawaii (UTC -10:00)"
  },
  {
    "name": "US/Indiana-Starke",
    "utc": "US - Indiana-Starke (UTC -05:00)"
  },
  {
    "name": "US/Michigan",
    "utc": "US - Michigan (UTC -04:00)"
  },
  {
    "name": "US/Mountain",
    "utc": "US - Mountain (UTC -06:00)"
  },
  {
    "name": "US/Pacific",
    "utc": "US - Pacific (UTC -07:00)"
  },
  {
    "name": "US/Samoa",
    "utc": "US - Samoa (UTC -11:00)"
  },
  {
    "name": "UTC",
    "utc": "UTC (UTC +00:00)"
  },
  {
    "name": "Universal",
    "utc": "Universal (UTC +00:00)"
  },
  {
    "name": "W-SU",
    "utc": "W-SU (UTC +03:00)"
  },
  {
    "name": "WET",
    "utc": "WET (UTC +01:00)"
  },
  {
    "name": "Zulu",
    "utc": "Zulu (UTC +00:00)"
  }
]

const props = defineProps({
  modelValue: String,
  disabled: Boolean
});

const emit = defineEmits(['update:modelValue']);

function onChangeTimezoneHandler(selected) {
  emit('update:modelValue', selected.selectedValue);
}

const isViewMode = computed(() => props.disabled);

const timeZoneOptionsList = computed(() =>
  timeZoneList.map(tz => ({
    value: tz.name,
    title: tz.utc  // previously `text`, now `title`
  }))
);
</script>
